import { render, staticRenderFns } from "./ResidentProfilesTable.vue?vue&type=template&id=35d7d708&"
import script from "./ResidentProfilesTable.vue?vue&type=script&lang=js&"
export * from "./ResidentProfilesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports